import { auth } from '@/lib/firebase';
import api from '@/lib/api';

const RESET = 'RESET';

const getDefaultState = () => ({});

export const state = getDefaultState();

export const mutations = {
  [RESET]() {
    // Object.assign(state, getDefaultState());
  },
};

export const getters = {};

export const actions = {
  reset({ commit }) {
    commit(RESET);
  },

  async fetchCalendar(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async saveCalendar(_, payload) {
    try {
      const token = await auth.currentUser.getIdToken();
      const id = payload.id;

      delete payload.id;

      const response = await api.put(
        `/calendars/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchCalendarSlots(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const id = params.id;
  
      delete params.id;

      const response = await api.get(
        `/calendars/${id}/slots`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchSuggestedScheduleTimes(_, params) {
    try {
    const token = await auth.currentUser.getIdToken(); 
      const response = await api.get(
        '/calendars/suggested-schedule-times',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchSlot(_, params) {
    const token = await auth.currentUser.getIdToken();
    const id = params.calendarId;

    delete params.calendarId;

    try {
      const response = await api.get(
        `/calendars/${ id }/slot`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );
  
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getAvailability(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/availability',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async createAvailability(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post(
        '/calendars/availabilities',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateAvailability(_, payload) {
    try {
      const token = await auth.currentUser.getIdToken();
      const id = payload.id;

      delete payload.id;

      const response = await api.put(
        `/calendars/availabilities/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async removeAvailability(_, id) {
    const token = await auth.currentUser.getIdToken();

    try {
      await api.delete(`/calendars/availabilities/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchCalendarAvailabilities(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/availabilities',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async deleteCalendarAvailability(_, { availabilityId, ...params }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.delete(
        `/calendars/availability/${availabilityId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getCalendarScopes() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/scopes',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getAccessTokens() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/access-tokens',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getAccessTokenKey(_, id) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        `/calendars/access-tokens/${id}/key`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async addAccessToken(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post(
        '/calendars/access-tokens',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async disableAccessToken(_, id) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.delete(
        `/calendars/access-tokens/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getGoogleConnection() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/google/connection',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getGoogleAuthUrl() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/google/auth-url',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getGoogleCalendars() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/google',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async addGoogleCalendar(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.put(
        '/calendars/google',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async removeGoogleCalendar() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.delete(
        '/calendars/google',
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  // Scheduling

  async fetchSchedules(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/schedules',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchSchedule(_, params) {
    try {
      const token = await auth.currentUser.getIdToken();
      const id = params.id;

      delete params.id;

      const response = await api.get(
        `/calendars/schedule/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async schedule(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post(
        '/calendars/schedule',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateSchedule(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;

    delete payload.id;

    try {
      const response = await api.put(
        `/calendars/schedule/${ id }`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async confirmSchedule(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;

    delete payload.id;

    try {
      await api.post(`/calendars/schedule/${ id }/confirm`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchPreSchedules(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/calendars/pre-schedules',
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async confirmPreSchedule(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;

    delete payload.id;

    try {
      await api.post(`/calendars/pre-schedule/${ id }/confirm`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async cancelPreSchedule(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;

    delete payload.id;

    try {
      await api.delete(`/calendars/pre-schedule/${ id }`, {
        headers: { Authorization: `Bearer ${token}` },
        params: payload,
      });
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async cancelSchedule(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;

    delete payload.id;

    try {
      await api.delete(
        `/calendars/schedule/${ id }`,
        {
          params: payload,
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateScheduleAttendance(_, payload) {
    const token = await auth.currentUser.getIdToken();
    const id = payload.id;
    try {
      const response = await api.patch(
        `/calendars/schedule/${id}/attendance`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
